/* eslint-disable no-redeclare */
interface ToHourOptions<T extends boolean> {
  returnDetails?: T;
}

interface ToHourObjectReturn {
  formated: string;
  hours: number;
  minutes: number;
  seconds: number;
  miliseconds: number;
}
type ToHourReturn<T> = T extends true ? ToHourObjectReturn : T extends false ? string : never;

export function toHour(microsseconds: number): string;
export function toHour<T extends boolean>(microsseconds: number, opts: ToHourOptions<T>): ToHourReturn<T>;
export function toHour<T extends boolean>(
  microsseconds: number,
  { returnDetails }: ToHourOptions<T> = { returnDetails: false as T }
): ToHourReturn<T> {
  const ms = microsseconds / 1000;

  const miliseconds = Math.floor((ms % 1000) / 100);
  const seconds = Math.floor((ms / 1000) % 60);
  const minutes = Math.floor((ms / (1000 * 60)) % 60);
  const hours = Math.floor((ms / (1000 * 60 * 60)) % 24);

  const formatTimeToPattern = (value: number): string => (value < 10 ? `0${value}` : `${value}`);

  const formated = `${formatTimeToPattern(hours)}:${formatTimeToPattern(minutes)}`;

  if (returnDetails) {
    return {
      formated,
      hours,
      minutes,
      seconds,
      miliseconds,
    } as ToHourReturn<T>;
  }

  return formated as ToHourReturn<T>;
}

/** Return hour pattern as microsseconds */
export function fromHour(
  value: string,
  { shouldConvertToMidnight }: { shouldConvertToMidnight: boolean } = { shouldConvertToMidnight: false }
): number {
  const [hours, minutes] = value.split(':');

  if (!hours || !minutes) {
    throw new Error('Cannot format hour to microsseconds');
  }

  const formatedHours = (hours === '00' && shouldConvertToMidnight ? 24 : Number(hours)) * 3600000000;
  const formatedMinutes = Number(minutes) * (3600000000 / 60);

  return formatedHours + formatedMinutes;
}

export function minutesToMicrosseconds(minutes: number): number {
  return minutes * 60 * 1000000;
}

export function secondsToMiliseconds(seconds: number): number {
  return seconds * 1000;
}

export function microssecondsToMilisseconds(microsseconds: number): number {
  return microsseconds / 1000;
}

export enum Days {
  Sunday = 'sunday',
  Monday = 'monday',
  Tuesday = 'tuesday',
  Wednesday = 'wednesday',
  Thursday = 'thursday',
  Friday = 'friday',
  Saturday = 'saturday',
}

export const DaysMapper: Record<Days, string> = {
  [Days.Sunday]: 'Domingo',
  [Days.Monday]: 'Segunda',
  [Days.Tuesday]: 'Terça',
  [Days.Wednesday]: 'Quarta',
  [Days.Thursday]: 'Quinta',
  [Days.Friday]: 'Sexta',
  [Days.Saturday]: 'Sabádo',
};
